// extracted by mini-css-extract-plugin
module.exports = {"links":"MobileFooter_links__V_pMR","footerLink":"MobileFooter_footerLink___v8pU"};